import { filterTypes } from "../constants";
import { isNil, isArray } from "lodash";
import moment from "moment-timezone";

const ISO_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss.SS";
const DUE_DATE_QUERY_FORMAT = "YYYY-MM-DD";
const DUE_DATE_QUERY_STRING_FORMAT = "MM/DD/YYYY";
const ADMIN_ASSIGNEE_TYPE = "Admin";

export const mapStoredFiltersToFilters = (storedFilters) => {
  return Object.entries(storedFilters).reduce((filters, [key, value]) => {
    if (isNil(value) || (isArray(value) && value.length === 0)) {
      return filters;
    }

    switch (key) {
      case filterTypes.CONSULT_DATE:
        const { from, to } = value;
        filters[key] = [moment(from), moment(to)];
        break;
      case filterTypes.CATEGORY:
        filters[key] = value[0] || null;
        break;
      case filterTypes.ASSIGNEES:
        filters[key] = value.map((value) => ({ value: parseInt(value.id) }));
        break;
      case filterTypes.MEMBERS:
        filters[key] = value.map((value) => ({ value: parseInt(value) }));
        break;
      case filterTypes.TYPES:
      case filterTypes.PRIORITIES:
      case filterTypes.STATUSES:
        filters[key] = value.map((value) => ({ value }));
        break;
      default:
        filters[key] = value;
    };

    return filters;
  }, {});
};

export const mapFiltersToQuery = (filters) => {
  return Object.entries(filters).reduce((queryParams, [key, value]) => {
    if (isNil(value) || (isArray(value) && value.length === 0)) {
      return queryParams;
    }

    switch (key) {
      case filterTypes.ASSIGNEES:
        queryParams[key] = value.map(({ value: id }) => ({ id, type: ADMIN_ASSIGNEE_TYPE }));
        break;
      case filterTypes.CONSULT_DATE: {
        const [startDate, endDate] = value;
        queryParams[key] = startDate && endDate && {
          from: moment(startDate).format(ISO_DATE_FORMAT),
          to: moment(endDate).format(ISO_DATE_FORMAT),
        };
        break;
      }
      case filterTypes.DUE_DATE: {
        const [startDate, endDate] = value;
        queryParams[key] = startDate && endDate && {
          from: moment(startDate).format(DUE_DATE_QUERY_FORMAT),
          to: moment(endDate).format(DUE_DATE_QUERY_FORMAT),
        };
        break;
      }
      case filterTypes.TYPES:
      case filterTypes.PRIORITIES:
      case filterTypes.STATUSES:
        queryParams[key] = value.map(({ value }) => value);
        break;
      case filterTypes.MEMBERS:
        queryParams[key] = value.map(({ value }) => parseInt(value));
        break;
      case filterTypes.CATEGORY:
        queryParams[key] = [value];
        break;
      default:
        queryParams[key] = value;
    };

    return queryParams;
  }, {});
};

export const mapFiltersToQueryString = (filters) => {
  return Object.entries(filters).reduce((queryString, [key, value]) => {
    if (isNil(value) || (isArray(value) && value.length === 0)) {
      return queryString;
    }

    switch (key) {
      case filterTypes.CONSULT_DATE:
      case filterTypes.DUE_DATE:
        const [startDate, endDate] = value;
        if (startDate && endDate) {
          queryString[key] = [
            moment(startDate).format(DUE_DATE_QUERY_STRING_FORMAT),
            moment(endDate).format(DUE_DATE_QUERY_STRING_FORMAT),
          ].join("-");
        }
        break;
      case filterTypes.ASSIGNEES:
      case filterTypes.TYPES:
      case filterTypes.PRIORITIES:
      case filterTypes.STATUSES:
      case filterTypes.MEMBERS:
        queryString[key] = value.map(({ value }) => value);
        break;
      default:
        queryString[key] = value;
    };

    return queryString;
  }, {});
};

export const mapQueryStringToFilters = (queryString) => {
  return Object.entries(queryString).reduce((filters, [key, value]) => {
    if (isNil(value) || (isArray(value) && value.length === 0)) {
      return filters;
    }

    switch (key) {
      case filterTypes.CONSULT_DATE:
      case filterTypes.DUE_DATE:
        const [startDate, endDate] = value.split("-");
        if (startDate && endDate) {
          filters[key] = [
            moment(startDate, DUE_DATE_QUERY_STRING_FORMAT).toDate(),
            moment(endDate, DUE_DATE_QUERY_STRING_FORMAT).toDate(),
          ];
        }
        break;
      case filterTypes.ASSIGNEES:
      case filterTypes.TYPES:
      case filterTypes.PRIORITIES:
      case filterTypes.STATUSES:
      case filterTypes.MEMBERS:
        filters[key] = isArray(value)
          ? value.map((value) => ({ value }))
          : [{ value }];
        break;
      default:
        filters[key] = value;
    };

    return filters;
  }, {});
};
